import { Component, Input } from '@angular/core';
import { EnvironmentService } from 'src/app/services/environment.service';
import { LookupOptionsData } from '../jurisdiction.domain';
import { AllDropdownKeys } from '../jurisdiction.constants';
import { CommonService } from 'src/app/services/common.service';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-connection-type',
  templateUrl: './connection-type.component.html',
})
export class ConnectionTypeComponent {
  showPowerConnectionInfo1 = this.environmentService.showPowerConnectionInfo1;
  powerConnectionTypeKey = AllDropdownKeys.PowerConnectionType;
  powerConnectionTypes: LookupOptionsData[] = this.commonService.getDropdownData(this.powerConnectionTypeKey);

  @Input() form: FormGroup;
  public showHeader: boolean = false;

  constructor(private environmentService: EnvironmentService, private commonService: CommonService) {}
}
